import { Component, Input } from '@angular/core';
import { Subscriber } from '@opentok/client';
import { UtilsService } from '../../../../../../services/utils/utils.service';
import { NgClass } from '@angular/common';

@Component({
  standalone: true,
  imports: [NgClass],
  selector: 'sas-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss']
})
export class CameraComponent {
  /**
   *  Subscripción a la sesión para mostrar vídeo y audio de la videoconferencia del participante.
   */
  @Input() subscriber!: Subscriber;
  /**
   * Se controla el cambio en la barra de herramientas de video.
  */
  @Input() hasVideo?: boolean;

  active = true;

  constructor( private readonly utilsService: UtilsService ) {}

    /**
   * Método que habilita y deshabilita la cámara.
   */
  toggleCamera() {
    if (this.hasVideo) {
      this.active = !this.active;
      console.log('Subscriber Cámera toggleCamera subscriber.subscribeToVideo ---->' + this.utilsService.getTodayWithHour());
      this.subscriber.subscribeToVideo(this.active);
    }
  }

}
